<template>
  <div class="intro-container">
    <h1 class="intro-title">날씨/시간/체질과 사주란?</h1>
    <p class="intro-description">
      날씨/시간/체질과 사주는
      <strong>사용자의 사주</strong>
      와
      <strong>현 시간 사주</strong>
      에 들어 있는 오행의 기운과
      <strong>현재 날씨</strong>
      를 바탕으로, 사용자에게 흐르고 있는 기운을 살펴보고,
      <strong>사용자의 체질</strong>
      을 고려하여 지금 가져야 할 마음가짐과 행동의 방향을 제시해 줍니다. 기운의
      흐름에 순응하여 내면의 균형을 되찾고, 보다 유연하고 지혜로운 하루를
      만들어보세요. ({{ LYD }}LYD 필요)
    </p>

    <div class="intro-actions">
      <label class="checkbox">
        <input type="checkbox" v-model="skipNext" />
        다시 보지 않기
      </label>
      <div class="buttons">
        <button @click="proceed">이용하기</button>
        <button @click="cancel">돌아가기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'

  const LYD = ref(import.meta.env.VITE_CHARGE_QIFLOW)
  const router = useRouter()
  const skipNext = ref(false)
  const storageKey = 'skipIntroDaily'
  const proceedTo = '/SetupSajuData?from=IntroDaily'

  function proceed() {
    if (skipNext.value) {
      localStorage.setItem(storageKey, 'true')
    }
    router.replace(proceedTo)
  }

  function cancel() {
    router.go(-1)
  }

  onMounted(() => {
    if (localStorage.getItem(storageKey) === 'true') {
      router.replace(proceedTo)
    }
  })
</script>

<style scoped>
  .intro-container {
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .intro-title {
    font-size: var(--font-size-16);
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .intro-description {
    font-size: var(--font-size-11);
    line-height: 1.6;
    margin-bottom: 2rem;
    width: 90%;
  }
  .intro-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .checkbox {
    font-size: var(--font-size-09);
  }

  .buttons {
    display: flex;
    gap: 1.2rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #333;
    color: white;
    cursor: pointer;
  }

  button:first-child {
    background-color: #4caf50; /* Green */
    color: white;
  }

  button:first-child:hover {
    background-color: #45a049;
  }

  button:last-child {
    background-color: #f44336; /* Red */
    color: white;
  }

  button:last-child:hover {
    background-color: #da190b;
  }
</style>
